export default {
    translations: {
        'zh': {
            'language': 'Chinese',
            'months': {
                'original': ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
                'abbr': ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
            },
            'days': ['日', '一', '二', '三', '四', '五', '六']
        }
    }
}


// WEBPACK FOOTER //
// ./src/util/DateLanguages.js